<div class="cart-item-actions-block" [class.order-item-grid]="inOrder">

  @if (!inOrder) {
  <app-shipping-selector [shippingMethods]="[]" [smallLabel]="true" [darkMode]="true" [appendTo]="'body'">
  </app-shipping-selector>
  @if(orderLine){
  <app-quantity-selector [loading]="loading$ | async" (quantityChangeForCart)="setQuantity($event)"
    [orderLine]="orderLine" [classess]="'w-100'" [quantity]="orderLine.quantity" [smallButtons]="true"
    [darkMode]="true">
  </app-quantity-selector>
  } @else {
  <app-quantity-selector [loading]="loading$ | async" [classess]="'w-100'" [quantity]="product.quantity"
    [smallButtons]="true" [darkMode]="true">
  </app-quantity-selector>
  }
  } @else if(inOrder){


  <app-order-status-block [order]="order" [showStatusDate]="false"></app-order-status-block>




  <div class="card-column shipping">
    <div class="label">Delivery</div>
    <div class="value">
      <!--
              {{order?.shippingLines?.[0].shippingMethod?.name}}   <br />
            -->
      @if(order?.shippingLines?.[0].priceWithTax > 0){
      @if(order?.shippingLines?.[0].priceWithTax | formatPrice | async; as deliveryPrice){
      {{deliveryPrice}}
      }

      } @else {
      Free
      }


    </div>
  </div>

  <div class="card-column quantity">
    <div class="label">QTY</div>
    <div class="value">{{orderLine?.quantity}}</div>
  </div>
  }



  <div>
    @if(orderLine){
    <app-delivery-items-table-price-block [orderLine]="orderLine"></app-delivery-items-table-price-block>
    } @else {
    <app-delivery-items-table-price-block [product]="product"></app-delivery-items-table-price-block>
    }
  </div>
</div>
